export default __webpack_public_path__ + "static/media/google-plus.c755fd58.svg";